<template>
    <div class="config">
      <config-form @saved="handleConfigSaved" />
    </div>
  </template>
  
  <script>
  import ConfigForm from '@/components/ConfigForm.vue'
  
  export default {
    name: 'Config',
    components: {
      ConfigForm
    },
    methods: {
      handleConfigSaved() {
        this.$message.success('配置保存成功')
        this.$router.push('/')
      }
    }
  }
  </script>
  


// WEBPACK FOOTER //
// src/views/Config.vue